import React, { useState } from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { facilityHasDepartmentMembers } from "reduxSlices/adminFacilitySlice"
import { useSCIMResourceManagement } from "hooks"
import NameFilter from "shared/NameFilter"
import UserSourceList from "./UserSourceList"

const SearchableMembers = ({ className = "" }) => {
  const [nameFilter, setNameFilter] = useState("")

  const departmentMembers = useSelector(facilityHasDepartmentMembers)

  const { departmentsManagedBySCIM } = useSCIMResourceManagement()

  if (departmentsManagedBySCIM && !departmentMembers) return null

  return (
    <div className={className}>
      <NameFilter
        className="mb-6"
        onChange={setNameFilter}
        value={nameFilter}
      />
      <UserSourceList className="max-h-[19rem] overflow-y-auto thin-scroll-bar transparent-scroll-track" nameFilter={nameFilter} />
    </div>
  )
}

SearchableMembers.propTypes = {
  className: types.string,
}

export default SearchableMembers
